var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-row"},[_c('div',{staticClass:"label",style:({textAlign: _vm.labelAlign,color:_vm.labelColor})},[_vm._v(" "+_vm._s(_vm.label))]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }